import {
  TExpirationDateType,
  TFail,
  TFailUI,
  TFileDataType,
} from './GeneralTypes';

export enum EVetRecordStatus {
  NOT_VERIFIED = 'NOT_VERIFIED',
  VERIFIED = 'VERIFIED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum EVetRecordStatusUi {
  NOT_VERIFIED = 'Not verified',
  VERIFIED = 'Verified',
  IN_PROGRESS = 'Verification in progress',
}

export type TAnimalVetRecordUi = {
  documentFiles: TFileDataType[];
  id: string;
  records: TAnimalVetRecordTypeUI[];
  canEdit: boolean;
};

export type TAnimalVetRecord = {
  documentFiles: TFileDataType[];
  id: string;
  records: TAnimalVetRecordTypeDB[];
};

export type TAnimalVetRecordTypeDB = {
  expiration?: TExpirationDateType;
  id: string;
  isExpired: false;
  type: TAnimalVetRecordVacTypeDB;
  verificationStatus?: EVetRecordStatus;
  isLocked?: boolean;
  requiredByVerificationConfiguration?: boolean;
  showTextWhetherDocumentIsRequiredOrNot?: boolean;
};
export type TAnimalVetRecordTypeUI = {
  expiration?: TExpirationDateType;
  id: string;
  isExpired: false;
  type: TAnimalVetRecordVacTypeUI;
  verificationStatus?: EVetRecordStatusUi;
  isLocked?: boolean;
  requiredByVerificationConfiguration?: boolean;
  showTextWhetherDocumentIsRequiredOrNot?: boolean;
};

export type TAnimalVetRecordVacTypeDB = {
  predefined: boolean;
  value: string;
};
export type TAnimalVetRecordVacTypeUI = {
  predefined: boolean;
  custom?: string;
  value: string;
};

export type TApplicationVetRecordsUI = TAnimalVetRecordUi & {
  fails?: TFailUI[];
};
export type TApplicationVetRecords = TAnimalVetRecord & {
  fails?: TFail;
};
